module.exports = __webpack_public_path__ + "img/hot-dish.f9110f6a.svg";